module.exports = __webpack_public_path__ + "static/img/01-acoustic-sim.94fec94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/01-acoustic-sim.jpg
// module id = J43A
// module chunks = 13